import {Box, Card, CardContent, CardHeader, Chip, IconButton, Stack, Tooltip, Typography} from "@mui/material"
import {useNavigate} from "react-router-dom"
import {useContext} from "react"
import Icon from "src/@core/components/icon";
import {Solicitation, SolicitationFields} from "../../types/solicitation/solicitationData";
import {dateFormatter} from "../../utils/formatters";
import {EntityWithIdFields} from "../../types/baseEntities";
import {SolicitudPreviewEstados} from "./dummyTypes";
import {CompanyContext} from "../solicitation-new/context/companyContext";
import {FontSubtitleThree} from "../solicitation-new/components/SharedTypography";
import {numberFormatter} from "../../utils/formatters/numberFormatter";
import SearchIcon from "@mui/icons-material/Search";
import {stringFormatter} from "../../utils/formatters/stringFormatter";


export const EstadoColorMap: (estado: SolicitudPreviewEstados) => 'info' | 'warning' | 'error' | 'success' | 'default' =
    (estado) => {
        if (estado === SolicitudPreviewEstados.Analisis || estado === SolicitudPreviewEstados.EnAprobacion || estado === SolicitudPreviewEstados.PendienteAprobacion){
            return 'info'
        }else if (estado === SolicitudPreviewEstados.Instrumentada || estado === SolicitudPreviewEstados.PendienteMonetizacion || estado === SolicitudPreviewEstados.Aprobada){
            return 'success'
        }else if (estado === SolicitudPreviewEstados.Desistida || estado === SolicitudPreviewEstados.DesistidaPorBanco || estado === SolicitudPreviewEstados.Cancelada || 
            estado === SolicitudPreviewEstados.Anulada || estado === SolicitudPreviewEstados.NoAcordada || estado === SolicitudPreviewEstados.Rechazada){
            return 'error'
        }else if (estado === SolicitudPreviewEstados.Pendiente || estado === SolicitudPreviewEstados.PendienteEnvio){
            return 'warning'
        }
        else{
            return 'default'
        }
    }



const SolicitationPreview = ({ solicitud }: { solicitud: Solicitation }) => {
    const notificacion = solicitud[SolicitationFields.HasActiveNotification]
    const {setClientSolicitationId} = useContext(CompanyContext)
    const navigator = useNavigate()
    

    return (
        <Card>
            <CardHeader
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    alignContent: 'flex-start',
                    justifyContent: 'flex-start',
                }}
                avatar={
                    <Tooltip title={notificacion ? '¡Hay novedades!' : 'Nada nuevo por acá.'}>
                        <IconButton color={notificacion ? 'warning' : 'default'}>
                            <Icon icon={notificacion ? 'mdi:bell' : 'mdi:bell-outline'} />
                        </IconButton>
                    </Tooltip>
                }

                title={<Typography variant='h6' align='left'># {solicitud[EntityWithIdFields.Id]}</Typography>}

                // title={<Title title={solicitud.id} estado={solicitud.estado} />}

                // subheader={<Subtitle subtitle={solicitud.destino} />}
                action={
                    <>
                    {
                        solicitud[SolicitationFields.SolicitationStateCode] === SolicitudPreviewEstados.Pendiente ?
                            <Tooltip  title='Editar solicitud'>
                                <IconButton onClick={() => {
                                    setClientSolicitationId(solicitud[EntityWithIdFields.Id])
                                    localStorage.setItem('solicitationId', `${solicitud[EntityWithIdFields.Id]}`)
                                    navigator('nueva-solicitud')
                                }}>
                                    <SearchIcon />
                                </IconButton>
                            </Tooltip>
                            :
                            <Tooltip  title='Ver solicitud'>
                                <IconButton onClick={() => {
                                    setClientSolicitationId(solicitud[EntityWithIdFields.Id])
                                    localStorage.setItem('solicitationId', `${solicitud[EntityWithIdFields.Id]}`)
                                    navigator(`/solicitudes/${solicitud[EntityWithIdFields.Id]}`)
                                }}>
                                    <SearchIcon />
                                </IconButton>
                            </Tooltip>
                    }
                    </>
                }
            />
            <CardContent sx={{ paddingBottom: 0 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Stack direction="column" alignItems="center" spacing={2} sx={{ width: '100%' }}>
                        <Chip
                            sx={{
                                height: '70px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '75%'
                            }}
                            color='default'
                            label={
                                <>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        {solicitud[SolicitationFields.Amount] && solicitud[SolicitationFields.Amount] !== 0 ? (
                                            <Typography fontWeight={600} fontSize={14}>
                                                ${numberFormatter.toStringWithDecimals(solicitud[SolicitationFields.Amount])}
                                            </Typography>
                                        ) : (
                                            <Typography fontWeight={600} fontSize={14}>
                                                Sin especificar
                                            </Typography>
                                        )}
                                        <Typography sx={{ color: 'text.secondary' }} fontSize={15}>
                                            Monto solicitado
                                        </Typography>
                                    </Box>
                                </>
                            }
                        />

                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <FontSubtitleThree text={'Fecha alta: '} />
                                <Typography fontSize={14} sx={{ color: 'text.secondary' }} ml={1}>
                                    {dateFormatter.toShortDate(solicitud[SolicitationFields.BeginDate])}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <FontSubtitleThree text={'Fecha envío: '} />
                                {solicitud[SolicitationFields.SentDate] ? (
                                    <Typography fontSize={14} sx={{ color: 'text.secondary' }} ml={1}>
                                        {dateFormatter.toShortDate(solicitud[SolicitationFields.SentDate])}
                                    </Typography>
                                ) : (
                                    <Typography fontSize={14} sx={{ color: 'text.secondary' }} ml={1}>
                                        - Sin enviar -
                                    </Typography>
                                )}
                            </Box>
                        </Box>

                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '5px' }}>
                            <Stack alignItems={'center'} direction={'row'} spacing={1} sx={{ flexWrap: 'nowrap' }}>
                                <Typography  fontWeight={700} align='left' fontSize={13}>{"Destino:"}</Typography>
                                {
                                    solicitud[SolicitationFields.OperationDestinationReasonDesc] ? 
                                        <Tooltip title={solicitud[SolicitationFields.OperationDestinationReasonDesc]}>
                                            <Typography sx={{ color: 'text.secondary' }} align='left' fontSize={13}>
                                                {stringFormatter.cutIfHaveMoreThan(solicitud[SolicitationFields.OperationDestinationReasonDesc], 43)}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography sx={{ color: 'text.secondary' }} align='left' fontSize={13}>- Sin especificar -</Typography>
                                }
                            </Stack>

                            <Stack alignItems={'center'} direction={'row'} spacing={1} sx={{ flexWrap: 'nowrap' }}>
                                <Typography  fontWeight={700} align='left' fontSize={13}>{"Tipo destino:"}</Typography>
                                <Typography sx={{ color: 'text.secondary' }} align='left' fontSize={13}>
                                    {solicitud[SolicitationFields.OperationDestinationDesc] ? solicitud[SolicitationFields.OperationDestinationDesc] : "- Sin especificar -"}
                                </Typography>
                            </Stack>
                        </Box>
                    </Stack>
                </Box>
            </CardContent>

        </Card>
    )
}

export default SolicitationPreview